import {ListOwnerInfo, RecipientSummary, RecipientlistToRecipientAssociation} from "@/models/entities/ModelHelpers";
import {RecipientListFilterCriteria} from "@/utilities/enums/Enums";
import {getGermanIsoString} from "@/utilities/helpers/GermanIsoStringHelper";

export default class RecipientList {
  id: number = -1;
  name: string = '';
  description?: string | null = null;
  owner: ListOwnerInfo = new ListOwnerInfo();
  recipientAssociations: RecipientlistToRecipientAssociation = new RecipientlistToRecipientAssociation();
  recipientCount: number = 0;
  recipientPreview: RecipientSummary[] = [];
  activeTicketCount: number = 0;
  totalTicketCount: number = 0;
  createdAt: string = getGermanIsoString();
  modifiedAt?: string | null = null;
  lastTicketSentAt?: string | null = null;
  isSelected: boolean = false;
  canEdit: boolean = true;
  canDelete: boolean = true;
  filterCriteria: RecipientListFilterCriteria|null = null;
  filterValue: string|null = null;

  constructor(data: Record<string, any> | undefined = undefined) {
    Object.assign(this, data);
  }
}
